class DFFPhotoService {
  static parseValue = (value) => {
    if (value) {
      return Array.isArray(value) ? value : [value];
    }
    return [];
  };


  static addPhotos = async (api, configuration, photos) => {
    api.onFieldPhotoChange(configuration.section, configuration.id, photos);
  };
  
}

export default DFFPhotoService;
